import { RouteObject } from 'react-router-dom';

import TaskListPage from '../../pages/task-list-pa';
// import CreateTaskDialog from '../../pages/task-list-pa/create-task/CreateTaskDialog';

const taskListRouter: RouteObject = {
  path: 'task-list',
  element: <TaskListPage />,
  children: [
    // {
    //   path: ':taskId/info',
    //   element: <TaskInformationDialog />,
    // },
    // {
    //   path: 'create',
    //   element: <CreateTaskDialog />,
    // },
  ],
};

export default taskListRouter;
